/* eslint-disable react/prop-types */
import React from 'react';
import { graphql, Link } from 'gatsby';
import { kebabCase } from 'lodash';
import useBusiness from '@bostonglobe/js-business/dist/react/useBusiness';
import { StaticImage } from 'gatsby-plugin-image';

import Layout from '~components/Layout';
import BodyElement from '~components/body/BodyElement';
import ArchieElement from '~components/body/ArchieElement';
import CandidateList from '~components/graphic/CandidateList';

import '~styles/modules/topper.scss';

const IndexPage = ({
  data: {
    arcStory,
    candidates,
    questions,
    images,
    smallimages,
  },
}) => {
  useBusiness({
    title: arcStory.headlines.basic,
    section: 'politics',
    author: 'Daigo Fujiwara, Milton Valencia, Sahar Fatima',
    otherSections: [],
    publishDate: 'date',
    wordCount: '0',
    meter: false,
    hideSocialConnect: false,
    hideProgressBar: false,
    pageId: `apps.${kebabCase(arcStory.headlines.basic)}`,
  });

  // sort the candidate list by their last name
  candidates.nodes.sort((a, b) => ((a.shortName < b.shortName) ? -1 : 1));
  return (
    <Layout>
      <CandidateList candidates={candidates.nodes} images={images.nodes} />
      <div className="topper">
        <h3 className="super benton-n6">
          <span className="super--check">
            <StaticImage src="../assets/images/ticks-color.svg" alt="" placeholder="blurred" />
          </span>
          Boston Mayoral Race
        </h3>
        <h1 className="miller-n6">{arcStory.headlines.basic}</h1>
      </div>
      {arcStory.bodyElements.map((element, index) => {
        if (element.archieJson) {
          return (
            <ArchieElement
              data={element.archieJson}
              key={index}
              questions={questions.nodes}
              candidates={candidates.nodes}
              smallimages={smallimages.nodes}
              images={images.nodes}
              relatedLinks={arcStory.relatedLinks}
            />
          );
        }
        return <BodyElement data={element} key={index} />;
      })}
    </Layout>
  );
};

export const pageQuery = graphql`
    query {
        arcStory(storyId: {eq: "KMGI2VS3XJEANBPNWN5KPS7JWU"}) {
          headlines {
            basic
          }
          promoImage {
            url
          }
          internal {
            description
          }
          bodyElements {
            type
            content
            archieJson
          }
          relatedLinks {
            headlines {
              basic
            }
            promoImage {
              url
              sizes {
                _480
              }
            }
            url
          }
        }
        candidates: allGoogleSheetMayorCandidates(filter: {status: {eq: "running"}}) {
          nodes {
            name
            shortName
            img
            desc
            q01
            q02
            q03
            q04
            q05
            q06
            q07
            q08
            q09
            q10
            q11
            q12
            q13
            q14
            q15
            q16
            q17
            q18
            q19
            q20
            q21
            q22
            resulttext
            c01
            c02
            # c03
            c04
            c05
            c06
            c07
            # c08
            c09
            c10
            c11
            # c12
            # c13
            c14
            c15
            c16
            # c17
            c18
            c19
            # c20
            c21
            # c22
          }
        }
        questions: allGoogleSheetMayorQuestons {
          nodes {
            qid
            title
            question
            a1
            a2
            a3
            a4
            topic
            relatedurl
          }
        }
        images: allFile(filter: {
          sourceInstanceName: {eq: "images"},
          extension: {eq: "png"}
        }) {
          nodes {
            base
            childImageSharp {
              gatsbyImageData (width: 500, placeholder: BLURRED)
            }
          }
        }
        smallimages: allFile(filter: {
          sourceInstanceName: {eq: "images"},
          extension: {eq: "png"}
        }) {
          nodes {
            base
            childImageSharp {
              gatsbyImageData (width: 50, placeholder: BLURRED)
            }
          }
        }
    }`;

export default IndexPage;
